// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.green-count {\r\n    color: #36b37e;\n}\n.amber-count {\r\n    color: #ffab00;\n}\n.red-count {\r\n    color: #de350b;\n}\n.no-count {\r\n    color: #b5b7ba;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
